"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DrawingToolsManager_callbacks, _DrawingToolsManager_defaultTextures, _DrawingToolsManager_eventEngine, _DrawingToolsManager_eventManager, _DrawingToolsManager_geometryManager, _DrawingToolsManager_geometryMathManager, _DrawingToolsManager_historyManager, _DrawingToolsManager_interactionManager, _DrawingToolsManager_keysPressed, _DrawingToolsManager_parentNode, _DrawingToolsManager_sceneParent, _DrawingToolsManager_settings, _DrawingToolsManager_textVisualizationManager, _DrawingToolsManager_uuidGenerator, _DrawingToolsManager_viewport, _DrawingToolsManager_closed, _DrawingToolsManager_continuousRenderingFlag, _DrawingToolsManager_eventListenerToken, _DrawingToolsManager_paused, _DrawingToolsManager_uuid, _DrawingToolsManager_scratchVec3_constraintMin, _DrawingToolsManager_scratchVec3_constraintMax;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawingToolsManager = void 0;
const viewer_1 = require("@shapediver/viewer");
const viewer_rendering_engine_intersection_restriction_engine_1 = require("@shapediver/viewer.rendering-engine.intersection-restriction-engine");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const gl_matrix_1 = require("gl-matrix");
const IDrawingToolsManager_1 = require("../interfaces/IDrawingToolsManager");
const GeometryManager_1 = require("./managers/geometry/GeometryManager");
const HistoryManager_1 = require("./managers/HistoryManager");
const InteractionManager_1 = require("./managers/interaction/InteractionManager");
const TextVisualizationManager_1 = require("./managers/TextVisualizationManager");
class DrawingToolsManager {
    // #endregion Properties (20)
    // #region Constructors (1)
    constructor(viewport, callbacks, settings, defaultTextures, parentNode) {
        // #region Properties (21)
        _DrawingToolsManager_callbacks.set(this, void 0);
        _DrawingToolsManager_defaultTextures.set(this, void 0);
        _DrawingToolsManager_eventEngine.set(this, viewer_shared_services_1.EventEngine.instance);
        _DrawingToolsManager_eventManager.set(this, void 0);
        _DrawingToolsManager_geometryManager.set(this, void 0);
        _DrawingToolsManager_geometryMathManager.set(this, void 0);
        _DrawingToolsManager_historyManager.set(this, void 0);
        _DrawingToolsManager_interactionManager.set(this, void 0);
        _DrawingToolsManager_keysPressed.set(this, {});
        _DrawingToolsManager_parentNode.set(this, void 0);
        _DrawingToolsManager_sceneParent.set(this, void 0);
        _DrawingToolsManager_settings.set(this, void 0);
        _DrawingToolsManager_textVisualizationManager.set(this, void 0);
        _DrawingToolsManager_uuidGenerator.set(this, viewer_shared_services_1.UuidGenerator.instance);
        _DrawingToolsManager_viewport.set(this, void 0);
        _DrawingToolsManager_closed.set(this, false);
        _DrawingToolsManager_continuousRenderingFlag.set(this, void 0);
        _DrawingToolsManager_eventListenerToken.set(this, void 0);
        _DrawingToolsManager_paused.set(this, false);
        _DrawingToolsManager_uuid.set(this, __classPrivateFieldGet(this, _DrawingToolsManager_uuidGenerator, "f").create());
        // Scratch vec3s reused across hot-path calls to avoid per-frame allocation.
        _DrawingToolsManager_scratchVec3_constraintMin.set(this, gl_matrix_1.vec3.create());
        _DrawingToolsManager_scratchVec3_constraintMax.set(this, gl_matrix_1.vec3.create());
        __classPrivateFieldSet(this, _DrawingToolsManager_viewport, viewport, "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_callbacks, callbacks, "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_settings, this.cleanSettings(settings), "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_defaultTextures, defaultTextures, "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_sceneParent, parentNode !== null && parentNode !== void 0 ? parentNode : viewer_1.sceneTree.root, "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_parentNode, new viewer_1.TreeNode(`DrawingToolsManager_${__classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f")}`), "f");
        __classPrivateFieldGet(this, _DrawingToolsManager_parentNode, "f").intersectionTest = false;
        __classPrivateFieldGet(this, _DrawingToolsManager_sceneParent, "f").addChild(__classPrivateFieldGet(this, _DrawingToolsManager_parentNode, "f"));
        viewer_1.sceneTree.root.updateVersion(false, false);
        __classPrivateFieldSet(this, _DrawingToolsManager_geometryMathManager, new viewer_rendering_engine_intersection_restriction_engine_1.GeometryMathManager(__classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f"), __classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").visualization), "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_geometryManager, new GeometryManager_1.GeometryManager(this), "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_interactionManager, new InteractionManager_1.InteractionManager(this), "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_textVisualizationManager, new TextVisualizationManager_1.TextVisualizationManager(this), "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_historyManager, new HistoryManager_1.HistoryManager(this), "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_eventManager, new viewer_rendering_engine_intersection_restriction_engine_1.EventManager(__classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f"), {
            onDown: this.onDown.bind(this),
            onUp: this.onUp.bind(this),
            onOut: this.onOut.bind(this),
            onMove: this.onMove.bind(this),
            onKeyDown: this.onKeyDown.bind(this),
            onKeyUp: this.onKeyUp.bind(this),
        }), "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_continuousRenderingFlag, __classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f").addFlag(viewer_1.FLAG_TYPE.CONTINUOUS_RENDERING), "f");
        // special case, the scene is still empty, so we create a grid by default and show the scene
        if (viewer_1.sceneTree.root.boundingBox.isEmpty())
            __classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f").show = true;
        // add listener for geometry changes, if autoUpdate is enabled the drawing tool will update automatically
        __classPrivateFieldSet(this, _DrawingToolsManager_eventListenerToken, __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").addListener(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.GEOMETRY_CHANGED, (e) => {
            const event = e;
            if (event.drawingToolsId !== __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"))
                return;
            if (event.temporary === false &&
                event.points !== undefined &&
                event.metaData !== undefined &&
                event.recordHistory !== false) {
                if (__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").general.autoUpdate &&
                    (__classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").insertionInteractionHandler
                        .insertionActive === false ||
                        viewer_shared_services_1.SystemInfo.instance.isMobile === true) &&
                    (__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.autoClose ||
                        __classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.close ===
                            __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").geometryState.closeLoop)) {
                    this.update();
                }
            }
        }), "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (22)
    get callbacks() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_callbacks, "f");
    }
    get closed() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_closed, "f");
    }
    get paused() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_paused, "f");
    }
    get defaultTextures() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_defaultTextures, "f");
    }
    get geometryManager() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f");
    }
    get geometryMathManager() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_geometryMathManager, "f");
    }
    get geometryState() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").geometryState;
    }
    get historyManager() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_historyManager, "f");
    }
    get indicesArrayLines() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").geometryState.indicesArrayLines;
    }
    get insertionActive() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").insertionInteractionHandler
            .insertionActive;
    }
    get interactionManager() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f");
    }
    get parentNode() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_parentNode, "f");
    }
    get positionArray() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").geometryState.positionArray;
    }
    get restrictionManager() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").restrictionManager;
    }
    get restrictions() {
        return this.restrictionManager.restrictions;
    }
    get settings() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_settings, "f");
    }
    get showDistanceLabels() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").showDistanceLabels;
    }
    set showDistanceLabels(value) {
        __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").showDistanceLabels = value;
    }
    get showPointLabels() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").showPointLabels;
    }
    set showPointLabels(value) {
        __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").showPointLabels = value;
    }
    get showPointerPosition() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").showPointerPosition;
    }
    set showPointerPosition(value) {
        __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").showPointerPosition = value;
    }
    get textVisualizationManager() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f");
    }
    get uuid() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f");
    }
    get viewport() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f");
    }
    // #endregion Public Getters And Setters (22)
    // #region Public Methods (28)
    /**
     * Apply position and size constraints to a proposed point position.
     * Position constraints clamp each axis independently.
     * Size constraints clamp the moved point so the geometry extent stays within [min, max].
     *
     * @param proposedPosition  The unconstrained candidate position.
     * @param pointIndex        The index of the point being moved/added. Pass the
     *                          current point count (or any value >= count) when adding
     *                          a new point so that all current points are treated as
     *                          "other" points.
     * @param overrides         Optional map of pointIndex→position for points that
     *                          are being moved in the same frame (e.g. other selected
     *                          points or already-computed adjacency targets). These
     *                          positions are used instead of the stored positions when
     *                          computing the geometry extent.
     */
    applyConstraints(proposedPosition, pointIndex, overrides, originalPositionOverride) {
        var _a, _b;
        const constraints = __classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.constraints;
        if (!constraints)
            return proposedPosition;
        const geometryState = (_a = __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f")) === null || _a === void 0 ? void 0 : _a.geometryState;
        const pointCount = (_b = geometryState === null || geometryState === void 0 ? void 0 : geometryState.getPointCount()) !== null && _b !== void 0 ? _b : (overrides ? overrides.size + 1 : 0);
        // Position constraints: clamp each axis to [min, max].
        const result = gl_matrix_1.vec3.clone(proposedPosition);
        if (constraints.position) {
            const posAxes = ["x", "y", "z"];
            for (let i = 0; i < 3; i++) {
                const c = constraints.position[posAxes[i]];
                if (c)
                    result[i] = Math.max(c[0], Math.min(c[1], result[i]));
            }
        }
        // Size constraints: keep geometry extent within [minSize, maxSize].
        if (constraints.size && pointCount > 0) {
            // Scratch vec3s reused from instance to avoid allocation.
            const min = __classPrivateFieldGet(this, _DrawingToolsManager_scratchVec3_constraintMin, "f");
            const max = __classPrivateFieldGet(this, _DrawingToolsManager_scratchVec3_constraintMax, "f");
            min[0] = min[1] = min[2] = Number.POSITIVE_INFINITY;
            max[0] = max[1] = max[2] = Number.NEGATIVE_INFINITY;
            // Prefer overrides when provided; fall back to geometryState.positionArray when available.
            const posArray = geometryState === null || geometryState === void 0 ? void 0 : geometryState.positionArray;
            for (let i = 0; i < pointCount; i++) {
                if (i === pointIndex)
                    continue;
                const base = i * 3;
                const overridePos = overrides === null || overrides === void 0 ? void 0 : overrides.get(i);
                const px = overridePos
                    ? overridePos[0]
                    : posArray
                        ? posArray[base]
                        : Number.NaN;
                const py = overridePos
                    ? overridePos[1]
                    : posArray
                        ? posArray[base + 1]
                        : Number.NaN;
                const pz = overridePos
                    ? overridePos[2]
                    : posArray
                        ? posArray[base + 2]
                        : Number.NaN;
                if (!isFinite(px))
                    continue;
                min[0] = Math.min(min[0], px);
                min[1] = Math.min(min[1], py);
                min[2] = Math.min(min[2], pz);
                max[0] = Math.max(max[0], px);
                max[1] = Math.max(max[1], py);
                max[2] = Math.max(max[2], pz);
            }
            // Tolerance for floating-point precision
            const SIZE_CONSTRAINT_EPSILON = 1e-5;
            const sizeAxes = ["x", "y", "z"];
            // The committed (pre-drag) position of the moving point, used to detect
            // when an edge control has crossed to the other side of the opposite edge.
            // When an originalPositionOverride is provided (e.g. from EdgeControl with
            // the drag-start position), use it so that the crossing detection always
            // refers to the true pre-drag side, even when movePointTemporary has
            // updated positionArray mid-drag.
            const originalPosition = originalPositionOverride !== null && originalPositionOverride !== void 0 ? originalPositionOverride : geometryState === null || geometryState === void 0 ? void 0 : geometryState.getPosition(pointIndex);
            for (let i = 0; i < 3; i++) {
                const c = constraints.size[sizeAxes[i]];
                if (!c)
                    continue;
                const [minSize, maxSize] = c;
                const newExtent = Math.max(max[i], result[i]) - Math.min(min[i], result[i]);
                // check if there is a maxSize constraint and if it is violated, if yes clamp to the valid range
                if (maxSize !== undefined &&
                    isFinite(maxSize) &&
                    newExtent > maxSize + SIZE_CONSTRAINT_EPSILON) {
                    if (result[i] <= min[i])
                        result[i] = max[i] - maxSize;
                    else
                        result[i] = min[i] + maxSize;
                }
                // check if there is a minSize constraint and if it is violated, if yes clamp to the valid range
                if (minSize !== undefined &&
                    isFinite(minSize) &&
                    newExtent < minSize - SIZE_CONSTRAINT_EPSILON) {
                    if (result[i] >= max[i] - SIZE_CONSTRAINT_EPSILON) {
                        // High-side case: the point is at or above max[i] (within epsilon
                        // to tolerate floating-point imprecision where result[i] and
                        // max[i] are computed from the same value via different paths and
                        // may differ by a sub-epsilon amount — e.g. when the dragged
                        // corner and a same-edge peer share the committed coordinate).
                        if (originalPosition !== undefined &&
                            originalPosition[i] <= min[i]) {
                            // Crossing case (low→high): the point originated on the low
                            // side but has now moved past the opposite edge. The sibling
                            // override contaminates max[i], so use min[i] as the stable
                            // reference instead.
                            result[i] = min[i] - minSize;
                        }
                        else {
                            // Standard high-side case: push it up from the low reference.
                            result[i] = min[i] + minSize;
                        }
                    }
                    else if (originalPosition !== undefined &&
                        originalPosition[i] >= max[i]) {
                        // Crossing case (high→low): the point originated on the high side
                        // but has now moved past the opposite edge. The sibling override
                        // contaminates min[i], so use max[i] as the stable reference.
                        result[i] = max[i] + minSize;
                    }
                    else {
                        // Standard low-side case: point is legitimately on the low side.
                        result[i] = max[i] - minSize;
                    }
                }
            }
        }
        return result;
    }
    /**
     * Add a point to the drawing tool.
     *
     * @param index
     * @param position
     * @returns
     */
    addPoint(index, position, metaData, temporary = false) {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_closed, "f"))
            return false;
        if (!__classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").canAddPoint()) {
            __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.MAXIMUM_POINTS, {
                viewportId: this.viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
                message: `The maximum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.maxPoints}) has been exceeded.`,
            });
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError(`The maximum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.maxPoints}) has been exceeded.`);
        }
        return __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").addPoint(index, position, metaData, temporary);
    }
    addPointTemporary(index, position, metaData) {
        return this.addPoint(index, position, metaData, true);
    }
    /**
     * Add a ray tracing intersection restriction to the drawing tool.
     *
     * @param planeProperties
     * @returns
     */
    addRestriction(properties, token) {
        if (!properties.id)
            properties.id = token || __classPrivateFieldGet(this, _DrawingToolsManager_uuidGenerator, "f").create();
        return __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").restrictionManager.addRestriction(properties);
    }
    canRedo() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_historyManager, "f").canRedo();
    }
    canUndo() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_historyManager, "f").canUndo();
    }
    pause() {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_closed, "f") || __classPrivateFieldGet(this, _DrawingToolsManager_paused, "f"))
            return;
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").onOut();
        __classPrivateFieldSet(this, _DrawingToolsManager_paused, true, "f");
    }
    continue() {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_closed, "f"))
            return;
        __classPrivateFieldSet(this, _DrawingToolsManager_paused, false, "f");
    }
    cancel() {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_closed, "f"))
            return;
        try {
            __classPrivateFieldGet(this, _DrawingToolsManager_callbacks, "f").onCancel();
        }
        catch (e) {
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError("An error occurred while cancelling the drawing tool.");
        }
        __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.CANCEL, {
            viewportId: this.viewport.id,
            drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
        });
        this.close();
    }
    close() {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_closed, "f"))
            return;
        if (__classPrivateFieldGet(this, _DrawingToolsManager_eventListenerToken, "f")) {
            __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").removeListener(__classPrivateFieldGet(this, _DrawingToolsManager_eventListenerToken, "f"));
            __classPrivateFieldSet(this, _DrawingToolsManager_eventListenerToken, undefined, "f");
        }
        if (__classPrivateFieldGet(this, _DrawingToolsManager_continuousRenderingFlag, "f"))
            __classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f").removeFlag(__classPrivateFieldGet(this, _DrawingToolsManager_continuousRenderingFlag, "f"));
        __classPrivateFieldGet(this, _DrawingToolsManager_eventManager, "f").close();
        __classPrivateFieldGet(this, _DrawingToolsManager_geometryMathManager, "f").close();
        __classPrivateFieldGet(this, _DrawingToolsManager_historyManager, "f").close();
        __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").close();
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").close();
        __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").close();
        __classPrivateFieldGet(this, _DrawingToolsManager_sceneParent, "f").removeChild(__classPrivateFieldGet(this, _DrawingToolsManager_parentNode, "f"));
        viewer_1.sceneTree.root.updateVersion(false, false);
        __classPrivateFieldSet(this, _DrawingToolsManager_closed, true, "f");
    }
    getPointsData() {
        return this.geometryState.getPointsData();
    }
    keyPressed(key) {
        if (Array.isArray(key)) {
            // check if one of the keys is pressed
            let result = false;
            for (let i = 0; i < key.length; i++) {
                result = result || this.keyPressCheck(key[i]);
            }
            return result;
        }
        else {
            return this.keyPressCheck(key);
        }
    }
    movePoint(index, position, metaData, temporary = false, skipConstraints) {
        __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").movePoint(index, position, metaData, temporary, skipConstraints);
    }
    movePointTemporary(index, position, metaData) {
        this.movePoint(index, position, metaData, true);
    }
    onDown(event, ray) {
        if (this.closed || __classPrivateFieldGet(this, _DrawingToolsManager_paused, "f"))
            return;
        __classPrivateFieldGet(this, _DrawingToolsManager_geometryMathManager, "f").localToWorldMatrix =
            __classPrivateFieldGet(this, _DrawingToolsManager_sceneParent, "f").worldMatrix;
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").onDown(event, this.transformRayToLocalSpace(ray));
    }
    onKeyDown(event, pointerInCanvas) {
        if (this.closed || __classPrivateFieldGet(this, _DrawingToolsManager_paused, "f"))
            return;
        if (!pointerInCanvas)
            return;
        __classPrivateFieldGet(this, _DrawingToolsManager_keysPressed, "f")[event.key] = true;
        const undoKeyPressed = this.keyPressed(__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").keyBindings.undo);
        const redoKeyPressed = this.keyPressed(__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").keyBindings.redo);
        /**
         * IF UNDO KEY IS PRESSED
         * - UNDO
         */
        if (undoKeyPressed) {
            __classPrivateFieldGet(this, _DrawingToolsManager_historyManager, "f").undo();
        }
        /**
         * IF REDO KEY IS PRESSED
         * - REDO
         */
        if (redoKeyPressed) {
            __classPrivateFieldGet(this, _DrawingToolsManager_historyManager, "f").redo();
        }
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").onKeyDown();
    }
    onKeyUp(event, pointerInCanvas) {
        if (this.closed || __classPrivateFieldGet(this, _DrawingToolsManager_paused, "f"))
            return;
        __classPrivateFieldGet(this, _DrawingToolsManager_keysPressed, "f")[event.key] = false;
    }
    onMove(event, ray) {
        if (this.closed || __classPrivateFieldGet(this, _DrawingToolsManager_paused, "f"))
            return;
        if (!__classPrivateFieldGet(this, _DrawingToolsManager_continuousRenderingFlag, "f"))
            __classPrivateFieldSet(this, _DrawingToolsManager_continuousRenderingFlag, __classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f").addFlag(viewer_1.FLAG_TYPE.CONTINUOUS_RENDERING), "f");
        __classPrivateFieldGet(this, _DrawingToolsManager_geometryMathManager, "f").localToWorldMatrix =
            __classPrivateFieldGet(this, _DrawingToolsManager_sceneParent, "f").worldMatrix;
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").onMove(event, this.transformRayToLocalSpace(ray));
    }
    onOut() {
        if (this.closed || __classPrivateFieldGet(this, _DrawingToolsManager_paused, "f"))
            return;
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").onOut();
        if (__classPrivateFieldGet(this, _DrawingToolsManager_continuousRenderingFlag, "f") &&
            viewer_shared_services_1.SystemInfo.instance.isMobile === false) {
            __classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f").removeFlag(__classPrivateFieldGet(this, _DrawingToolsManager_continuousRenderingFlag, "f"));
            __classPrivateFieldSet(this, _DrawingToolsManager_continuousRenderingFlag, undefined, "f");
        }
    }
    onUp(event) {
        if (this.closed || __classPrivateFieldGet(this, _DrawingToolsManager_paused, "f"))
            return;
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").onUp(event);
    }
    /**
     * Cancel any in-progress hover or drag interaction without closing the drawing tool.
     */
    cancelDrag() {
        if (this.closed || __classPrivateFieldGet(this, _DrawingToolsManager_paused, "f"))
            return;
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").onOut();
    }
    /**
     * Returns true if a point or control is currently hovered or being dragged.
     */
    isInteractionActive() {
        var _a;
        const helper = __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").interactionManagerHelper;
        const controls = __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").controlsManager;
        return (helper.hoveredPoint !== undefined ||
            helper.dragging ||
            (controls === null || controls === void 0 ? void 0 : controls.hoveredControlIndex) !== undefined ||
            ((_a = controls === null || controls === void 0 ? void 0 : controls.isDraggingControl) !== null && _a !== void 0 ? _a : false));
    }
    redo() {
        __classPrivateFieldGet(this, _DrawingToolsManager_historyManager, "f").redo();
    }
    /**
     * Remove a point from the drawing tool.
     *
     * @param index
     * @returns
     */
    removePoint(index, temporary = false) {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_closed, "f"))
            return false;
        if (!this.geometryState.canRemovePoint()) {
            __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.MINIMUM_POINTS, {
                viewportId: this.viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
                message: `The minimum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints}) has not been met.`,
            });
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError(`The minimum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints}) has not been met.`);
        }
        return __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").removePoint(index, temporary);
    }
    removePointTemporary(index) {
        return this.removePoint(index, true);
    }
    removePoints(indices) {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_closed, "f"))
            return;
        if (!this.geometryState.canRemovePoint(indices.length)) {
            __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.MINIMUM_POINTS, {
                viewportId: this.viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
                message: `The minimum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints}) has not been met.`,
            });
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError(`The minimum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints}) has not been met.`);
        }
        __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").removePoints(indices);
    }
    /**
     * Remove a restriction from the drawing tool.
     *
     * @param token
     */
    removeRestriction(token) {
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").restrictionManager.removeRestriction(token);
    }
    resetMaterialIndices() {
        __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").resetMaterialIndices();
        const disabledPoints = __classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.disabledPoints;
        if (disabledPoints) {
            for (const idx of disabledPoints) {
                this.updateMaterialIndex(idx, IDrawingToolsManager_1.MATERIAL_INDEX.DISABLED);
            }
        }
    }
    undo() {
        __classPrivateFieldGet(this, _DrawingToolsManager_historyManager, "f").undo();
    }
    update() {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_closed, "f"))
            return;
        const pointsCount = this.geometryState.getPointCount();
        if (__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints !== undefined &&
            pointsCount < __classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints) {
            __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.MINIMUM_POINTS, {
                viewportId: this.viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
                message: `The minimum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints}) has not been met. Current number of points: ${pointsCount}.`,
            });
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError(`The minimum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints}) has not been met. Current number of points: ${pointsCount}.`);
        }
        else if (__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.maxPoints !== undefined &&
            pointsCount > __classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.maxPoints) {
            __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.MAXIMUM_POINTS, {
                viewportId: this.viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
                message: `The maximum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.maxPoints}) has been exceeded. Current number of points: ${pointsCount}.`,
            });
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError(`The maximum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.maxPoints}) has been exceeded. Current number of points: ${pointsCount}.`);
        }
        else if (__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.mode === "lines" &&
            !(__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.autoClose ||
                __classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.close ===
                    __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").geometryState.closeLoop) &&
            pointsCount > 2) {
            __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.UNCLOSED_LOOP, {
                viewportId: this.viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
                message: "The geometry is not closed, but is required to be closed.",
            });
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError("The geometry is not closed, but is required to be closed.");
        }
        else {
            const pointsData = this.geometryState.getPointsData();
            try {
                __classPrivateFieldGet(this, _DrawingToolsManager_callbacks, "f").onUpdate(pointsData, this.geometryState.metadataArray);
                __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.UPDATE, {
                    viewportId: this.viewport.id,
                    drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
                });
            }
            catch (e) {
                throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError("An error occurred while updating the drawing tool.");
            }
            if (__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").general.closeOnUpdate)
                this.close();
            return {
                pointsData,
                metaData: this.geometryState.metadataArray,
            };
        }
    }
    updateMaterialIndex(index, materialIndex) {
        __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").updateMaterialIndex(index, materialIndex);
    }
    updateTextVisualization() {
        __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").createPointLabels();
        __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").createDistanceLabels();
    }
    // #endregion Public Methods (28)
    // #region Private Methods (2)
    cleanSettings(settingsOptional) {
        if (typeof settingsOptional === "string")
            settingsOptional = JSON.parse(settingsOptional);
        const settings = {
            geometry: {
                points: [],
                mode: "lines",
                close: true,
                autoClose: false,
            },
            controls: [],
            restrictions: {},
            visualization: {
                distanceMultiplicationFactor: 2,
                pointLabels: false,
                pointerPosition: true,
                distanceLabels: true,
                points: {
                    size_0: 15,
                    size_1: 20,
                    size_2: 15,
                    size_3: 20,
                    size_4: 15,
                    size_5: 20,
                    size_6: 10,
                    color_0: "#0d44f0",
                    color_1: "#197aeb",
                    color_2: "#9e27d8",
                    color_3: "#bc47fd",
                    color_4: "#00ff78",
                    color_5: "#00ff78",
                    color_6: "#888888",
                },
                lines: {
                    color: "#0d44f0",
                },
            },
            keyBindings: {
                insert: ["Insert", "+"],
                delete: ["Delete", "-"],
                confirm: "Enter",
                cancel: "Escape",
                undo: "Control+z",
                redo: "Control+y",
            },
            general: {
                autoStart: true,
                autoUpdate: false,
                closeOnUpdate: false,
                displayUnit: "",
                enableTranslation: true,
                enableInsertion: true,
                enableDeletion: true,
                enableSelection: true,
            },
        };
        const isUndefinedOrNull = (value) => value === undefined || value === null;
        if (!isUndefinedOrNull(settingsOptional.geometry)) {
            settings.geometry = {
                points: isUndefinedOrNull(settingsOptional.geometry.points)
                    ? []
                    : settingsOptional.geometry.points,
                mode: settingsOptional.geometry.mode === "points"
                    ? "points"
                    : "lines",
                minPoints: settingsOptional.geometry.minPoints,
                maxPoints: settingsOptional.geometry.maxPoints,
                strictMinMaxPoints: isUndefinedOrNull(settingsOptional.geometry.strictMinMaxPoints)
                    ? true
                    : settingsOptional.geometry.strictMinMaxPoints,
                close: isUndefinedOrNull(settingsOptional.geometry.close)
                    ? true
                    : settingsOptional.geometry.close,
                autoClose: isUndefinedOrNull(settingsOptional.geometry.autoClose)
                    ? true
                    : settingsOptional.geometry.autoClose,
                weightedAdjacency: settingsOptional.geometry.weightedAdjacency,
                disabledPoints: settingsOptional.geometry.disabledPoints,
                constraints: settingsOptional.geometry.constraints,
            };
        }
        if (!isUndefinedOrNull(settingsOptional.controls)) {
            settings.controls = [];
            for (const control of settingsOptional.controls) {
                if (!control)
                    continue;
                if (control.type === "edge") {
                    const edgeControl = control;
                    if (edgeControl.direction === undefined ||
                        edgeControl.point1 === undefined ||
                        edgeControl.point2 === undefined) {
                        continue;
                    }
                    edgeControl.direction = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), edgeControl.direction);
                    settings.controls.push(edgeControl);
                }
            }
        }
        if (!isUndefinedOrNull(settingsOptional.visualization)) {
            settings.visualization = {
                distanceMultiplicationFactor: isUndefinedOrNull(settingsOptional.visualization.distanceMultiplicationFactor)
                    ? 2
                    : settingsOptional.visualization
                        .distanceMultiplicationFactor,
                pointLabels: isUndefinedOrNull(settingsOptional.visualization.pointLabels)
                    ? false
                    : settingsOptional.visualization.pointLabels,
                pointerPosition: isUndefinedOrNull(settingsOptional.visualization.pointerPosition)
                    ? true
                    : settingsOptional.visualization.pointerPosition,
                distanceLabels: isUndefinedOrNull(settingsOptional.visualization.distanceLabels)
                    ? true
                    : settingsOptional.visualization.distanceLabels,
                points: isUndefinedOrNull(settingsOptional.visualization.points)
                    ? {
                        size_0: 15,
                        size_1: 20,
                        size_2: 15,
                        size_3: 20,
                        size_4: 15,
                        size_5: 20,
                        size_6: 10,
                        color_0: "#0d44f0",
                        color_1: "#197aeb",
                        color_2: "#9e27d8",
                        color_3: "#bc47fd",
                        color_4: "#00ff78",
                        color_5: "#00ff78",
                        color_6: "#888888",
                    }
                    : settingsOptional.visualization.points,
                lines: isUndefinedOrNull(settingsOptional.visualization.lines)
                    ? {
                        color: "#0d44f0",
                    }
                    : settingsOptional.visualization.lines,
                wireframe: isUndefinedOrNull(settingsOptional.visualization.wireframe)
                    ? undefined
                    : settingsOptional.visualization.wireframe,
                wireframeColor: isUndefinedOrNull(settingsOptional.visualization.wireframeColor)
                    ? undefined
                    : settingsOptional.visualization.wireframeColor,
                edgeControlVisualization: isUndefinedOrNull(settingsOptional.visualization.edgeControlVisualization)
                    ? undefined
                    : settingsOptional.visualization.edgeControlVisualization,
            };
        }
        if (!isUndefinedOrNull(settingsOptional.keyBindings)) {
            settings.keyBindings = {
                insert: isUndefinedOrNull(settingsOptional.keyBindings.insert)
                    ? ["Insert", "+"]
                    : settingsOptional.keyBindings.insert,
                delete: isUndefinedOrNull(settingsOptional.keyBindings.delete)
                    ? ["Delete", "-"]
                    : settingsOptional.keyBindings.delete,
                confirm: isUndefinedOrNull(settingsOptional.keyBindings.confirm)
                    ? "Enter"
                    : settingsOptional.keyBindings.confirm,
                cancel: isUndefinedOrNull(settingsOptional.keyBindings.cancel)
                    ? "Escape"
                    : settingsOptional.keyBindings.cancel,
                undo: isUndefinedOrNull(settingsOptional.keyBindings.undo)
                    ? "Control+z"
                    : settingsOptional.keyBindings.undo,
                redo: isUndefinedOrNull(settingsOptional.keyBindings.redo)
                    ? "Control+y"
                    : settingsOptional.keyBindings.redo,
            };
        }
        if (!isUndefinedOrNull(settingsOptional.general)) {
            settings.general = {
                autoStart: isUndefinedOrNull(settingsOptional.general.autoStart)
                    ? true
                    : settingsOptional.general.autoStart,
                autoUpdate: isUndefinedOrNull(settingsOptional.general.autoUpdate)
                    ? false
                    : settingsOptional.general.autoUpdate,
                closeOnUpdate: isUndefinedOrNull(settingsOptional.general.closeOnUpdate)
                    ? false
                    : settingsOptional.general.closeOnUpdate,
                displayUnit: isUndefinedOrNull(settingsOptional.general.displayUnit)
                    ? ""
                    : settingsOptional.general.displayUnit,
                enableTranslation: isUndefinedOrNull(settingsOptional.general.enableTranslation)
                    ? true
                    : settingsOptional.general.enableTranslation,
                enableInsertion: isUndefinedOrNull(settingsOptional.general.enableInsertion)
                    ? true
                    : settingsOptional.general.enableInsertion,
                enableDeletion: isUndefinedOrNull(settingsOptional.general.enableDeletion)
                    ? true
                    : settingsOptional.general.enableDeletion,
                enableSelection: isUndefinedOrNull(settingsOptional.general.enableSelection)
                    ? true
                    : settingsOptional.general.enableSelection,
            };
        }
        const min = gl_matrix_1.vec3.fromValues(Infinity, Infinity, Infinity);
        const max = gl_matrix_1.vec3.fromValues(-Infinity, -Infinity, -Infinity);
        for (let i = 0; i < settings.geometry.points.length; i++) {
            const point = settings.geometry.points[i];
            min[0] = Math.min(min[0], point[0]);
            min[1] = Math.min(min[1], point[1]);
            min[2] = Math.min(min[2], point[2]);
            max[0] = Math.max(max[0], point[0]);
            max[1] = Math.max(max[1], point[1]);
            max[2] = Math.max(max[2], point[2]);
        }
        if (isUndefinedOrNull(settingsOptional.restrictions) ||
            Object.keys(settingsOptional.restrictions).length === 0) {
            settings.restrictions["plane"] = { type: viewer_rendering_engine_intersection_restriction_engine_1.RESTRICTION_TYPE.PLANE };
        }
        else {
            settings.restrictions = settingsOptional.restrictions;
        }
        return settings;
    }
    keyPressCheck(key) {
        const pressedKeys = Object.keys(__classPrivateFieldGet(this, _DrawingToolsManager_keysPressed, "f")).filter((key) => __classPrivateFieldGet(this, _DrawingToolsManager_keysPressed, "f")[key] === true);
        // check if it the only key that is pressed
        if (key.includes("+") && key.length > 1) {
            const keys = key.split("+");
            // there are more keys pressed than the keys in the combination
            if (keys.length !== pressedKeys.length)
                return false;
            let result = true;
            for (let i = 0; i < keys.length; i++)
                result = result && (__classPrivateFieldGet(this, _DrawingToolsManager_keysPressed, "f")[keys[i]] || false);
            return result;
        }
        else {
            // there are also other keys pressed
            if (pressedKeys.length > 1)
                return false;
            return __classPrivateFieldGet(this, _DrawingToolsManager_keysPressed, "f")[key] || false;
        }
    }
    /**
     * Transform a point from the parent node's local space back to world space.
     * Used to convert local-space positions (stored in positionArray) to world
     * space when they need to be passed to world-space APIs (e.g. restriction
     * startPoint metadata that expects world-space coordinates).
     * When no custom parent is set (sceneTree.root), returns the point unchanged.
     */
    localToWorldPoint(p) {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_sceneParent, "f") === viewer_1.sceneTree.root)
            return p;
        return gl_matrix_1.vec3.transformMat4(gl_matrix_1.vec3.create(), p, __classPrivateFieldGet(this, _DrawingToolsManager_sceneParent, "f").worldMatrix);
    }
    /**
     * If the DT is attached to a parent node with a non-identity world matrix,
     * transform the incoming world-space ray into the parent's local space so
     * that restrictions, drag deltas, and weightedAdjacency all operate in the
     * same coordinate frame as the stored point positions.
     * When no custom parent is set (sceneTree.root), worldMatrix is identity and
     * the ray is returned unchanged.
     */
    transformRayToLocalSpace(ray) {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_sceneParent, "f") === viewer_1.sceneTree.root)
            return ray;
        const invMatrix = gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), __classPrivateFieldGet(this, _DrawingToolsManager_sceneParent, "f").worldMatrix);
        if (!invMatrix)
            return ray;
        const localOrigin = gl_matrix_1.vec3.transformMat4(gl_matrix_1.vec3.create(), ray.origin, invMatrix);
        // Direction is a free vector — apply only the rotation/scale part (w=0).
        const m = invMatrix;
        const d = ray.direction;
        const localDirection = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.fromValues(m[0] * d[0] + m[4] * d[1] + m[8] * d[2], m[1] * d[0] + m[5] * d[1] + m[9] * d[2], m[2] * d[0] + m[6] * d[1] + m[10] * d[2]));
        return { origin: localOrigin, direction: localDirection };
    }
}
exports.DrawingToolsManager = DrawingToolsManager;
_DrawingToolsManager_callbacks = new WeakMap(), _DrawingToolsManager_defaultTextures = new WeakMap(), _DrawingToolsManager_eventEngine = new WeakMap(), _DrawingToolsManager_eventManager = new WeakMap(), _DrawingToolsManager_geometryManager = new WeakMap(), _DrawingToolsManager_geometryMathManager = new WeakMap(), _DrawingToolsManager_historyManager = new WeakMap(), _DrawingToolsManager_interactionManager = new WeakMap(), _DrawingToolsManager_keysPressed = new WeakMap(), _DrawingToolsManager_parentNode = new WeakMap(), _DrawingToolsManager_sceneParent = new WeakMap(), _DrawingToolsManager_settings = new WeakMap(), _DrawingToolsManager_textVisualizationManager = new WeakMap(), _DrawingToolsManager_uuidGenerator = new WeakMap(), _DrawingToolsManager_viewport = new WeakMap(), _DrawingToolsManager_closed = new WeakMap(), _DrawingToolsManager_continuousRenderingFlag = new WeakMap(), _DrawingToolsManager_eventListenerToken = new WeakMap(), _DrawingToolsManager_paused = new WeakMap(), _DrawingToolsManager_uuid = new WeakMap(), _DrawingToolsManager_scratchVec3_constraintMin = new WeakMap(), _DrawingToolsManager_scratchVec3_constraintMax = new WeakMap();
//# sourceMappingURL=DrawingToolsManager.js.map